<template>
  <component :is="appropriateComponent()"></component>
</template>

<script>
import FeedbackLoggedIn from "@/components/feedback/FeedbackLoggedIn.vue";
import FeedbackLoggedOut from "@/components/feedback/FeedbackLoggedOut.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    FeedbackLoggedIn,
    FeedbackLoggedOut
  },
  created(){
     this.newTitle("Feedback");
  },
  methods: {
    ...mapActions([ "newTitle"]),
    
    appropriateComponent() {
      if (Object.keys(this.user).length == 0) {
        return "FeedbackLoggedOut";
      } else {
        return "FeedbackLoggedIn";
      }
    }
  },
  computed:{
        ...mapState({
      user: state => state.user.user,
      title: state => state.titlemessage.titletext
    }),
  }
};
</script>

<style scoped>
.center-page {
  display: inline-block;
  text-align: center;
  margin: 0 auto;
  width: 80%;
}
</style>